import ArrowDownIcon from "@/components/icons/arrow-down"

interface BalanceProps {
  totalPayments: number;
  totalWithdrawals: number;
}

export default function Balance({
  totalPayments,
  totalWithdrawals,
}: BalanceProps) {
  return (
    <div className="flex flex-row justify-between">
      <div className="flex flex-col gap-1 basis-1 flex-grow pr-6">
        <div className="text-sm font-normal text-gray-300 flex flex-row items-center gap-2">
          <div className="flex flex-row p-1 items-center justify-center bg-green-50 rounded-full">
            <div className=" text-green-500">
              <ArrowDownIcon direction="down" size={15} />
            </div>
          </div>
          Received
        </div>
        <div className="text-md font-semibold">${totalPayments.toFixed(2)}</div>
      </div>
      <div className="flex flex-col gap-1 basis-1 flex-grow items-start border-l border-l-gray-100 pl-6">
        <div className="text-sm font-normal text-gray-300 flex flex-row items-center gap-2">
          <div className="flex flex-row p-1 items-center justify-center bg-red-50 rounded-full">
            <div className=" text-red-500">
              <ArrowDownIcon direction="up" size={15} />
            </div>
          </div>
          Sent
        </div>
        <div className="text-md font-semibold">
          ${totalWithdrawals.toFixed(2)}
        </div>
      </div>
    </div>
  )
}
